/**
 * Orders two ids. They reach the UI as decimal strings (the cache normalizes
 * bigints), so a plain `<` would compare them as text and put "100" before "78".
 */
export const compareIds = (a: bigint | string, b: bigint | string): number => {
  const x = BigInt(a);
  const y = BigInt(b);
  return x < y ? -1 : x > y ? 1 : 0;
};
